export enum ERoundingMethod {
    SevenMinuteRule = 0,
    TwentyThreeMinuteCustomBreakRoundingRule = 1,
    ThreeMinuteRule = 2,
    OneMinuteRule = 3
}

export interface IRoundingRuleItem {
    Id: string
    Name: string
    RoundingMethod: ERoundingMethod
}